import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { EventMaster, EventsMastersInput } from '@/shared/models/event-master.model';
import { GET_EVENT_MASTERS } from '@/shared/services/queries/event-masters.graphql';

@Injectable({
  providedIn: 'root',
})
export class EventMastersService {
  private readonly apollo = inject(Apollo);

  getEventMasters(filter: EventsMastersInput): Observable<EventMaster[]> {
    return this.apollo
      .watchQuery<{ eventsMasters: EventMaster[] }>({
        query: GET_EVENT_MASTERS,
        variables: { filter },
      })
      .valueChanges.pipe(map((r) => r.data.eventsMasters));
  }
}
